<template>
  <div>
    <div class="containerBox">
      <h2 class="marginTop30">官方选房师绑定楼盘</h2>
      <div class="marginTop30">
        <el-button type="primary" @click="centerDialogVisible = true"
          >新增人员</el-button
        >
      </div>
      <div class="marginTop30">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column
            prop="saleInfo.user_name"
            label="姓名"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="绑定楼盘"
            width="500"
            align="center"
          >
            <template slot-scope="scope" >
              <div class="estates">
                <div v-for="(item, index) in scope.row.estateInfos" :key="index">
                  <div>{{ item.real_estate_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="标签" width="280" align="center">
            <template slot-scope="scope1">
              <el-tag :key="index" v-for="(tag, index) in scope1.row.labels">
                {{ tag }}
              </el-tag>
              <br/>
              <el-button
                class="button-new-tag"
                size="small"
                @click="showInput(scope1.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="photo" label="照片" width="280" align="center">
            <template slot-scope="scope2">
              <input type="file" @change="chooseImage($event, scope2.row)" />
              <div class="imageBox" v-if="scope2.row.photo">
                <img
                  :src="scope2.row.photo"
                  preview="1"
                  mode="widthFix"
                  style="width: 100px"
                />
                <button @click="delImage(scope2.row)">删除</button>
              </div>
              <el-button type="primary" @click="upImage(scope2.row)">
                保存</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="photo" label="操作" width="180" align="center">
            <template slot-scope="scope3">
              <el-button type="primary" @click="handleClick(scope3.row, 1)">
                新增</el-button
              >
              <el-button type="danger" @click="handleClick(scope3.row, 2)">
                删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="绑定"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="occupancyContainer">
        <input
          type="text"
          @keydown.enter="searchUser"
          placeholder="用户搜索"
          v-model="searchUserName"
        />
        <div>
          <div style="display: inline-block">
            <div v-if="nameSearchUsers.length" class="normal">
              <el-select
                v-model="search"
                filterable
                placeholder="绑定楼盘"
                default-first-option
                :remote-method="searchEstate"
                remote
              >
                <el-option
                  v-for="(item, index) in matchEstates"
                  :key="index"
                  :label="item.real_estate_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div v-if="Object.keys(userInfo).length !== 0">
              <el-tag> {{ userInfo.user_name }} </el-tag>
            </div>

            <div
              v-for="item in nameSearchUsers"
              :key="item.id"
              style="display: flex; align-items: center; margin-top: 20px"
            >
              <img
                :src="item.head_url"
                alt="没有头像"
                style="width: 50px; height: 50px; border-radius: 50%"
              />
              <div style="margin-left: 10px">{{ item.user_name }}</div>
              <div><el-button @click="selectUser(item)">选定</el-button></div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEstate(1)">新 增</el-button>
        <!-- <el-button type="danger" @click="handleEstate(2)">删 除</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="标签" :visible.sync="dialogVisible" width="30%">
      <el-tag
        v-for="(tag, index) in label"
        :key="index"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
      >
        {{ tag }}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput2"
        >新增标签</el-button
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyTag()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="操作" :visible.sync="handleVisible" width="30%" center="">
      <div style="display: flex; justify-content: center">
        <el-select
          v-if="handleType === 1"
          v-model="search"
          filterable
          placeholder="选择楼盘"
          default-first-option
          :remote-method="searchEstate"
          remote
        >
          <el-option
            v-for="(item, index) in matchEstates"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="search"
          filterable
          placeholder="选择楼盘"
        >
          <el-option
            v-for="(item, index) in estateInfos"
            :key="index"
            :label="item.real_estate_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBind(1)">新增</el-button>
        <el-button type="danger" @click="handleBind(2)">删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      search: "",
      userInfo: {},
      searchName: "",
      searchUserName: "",
      nameSearchUsers: [],
      handleType: 1,
      matchEstates: [],
      centerDialogVisible: false,
      inputVisible: false,
      dialogVisible: false,
      handleVisible: false,
      inputValue: "",
      label: [],
      estateInfos:[],
      sale_id: "",
      imageSrc: "",
    };
  },
  mounted() {
    this.getXiaojiSale();
  },
  methods: {
    getXiaojiSale() {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "getXiaojiSale", {})
        .then(function (res) {
          console.log(res);
          that.tableData = res.data.result;
        });
    },

    handleEstate(e) {
      console.log(this.search);
      let that = this;
      if (Object.keys(that.userInfo).length === 0) {
        that.$message({
          type: "warning",
          message: "请先选择用户",
        });
        return;
      }
      if (that.search === "") {
        that.$message({
          type: "warning",
          message: "请先选择绑定楼盘",
        });
        return;
      }
      let param = {
        estate_id: that.search,
        sale_id: that.userInfo.id,
      };
      if (e === 1) {
        that.$axios
          .post(that.$url_prefix + "setXiaojiSale", param)
          .then(function (res) {
            console.log(res);
            that.centerDialogVisible = false;
            that.getXiaojiSale();
            that.search = "";
            that.userInfo = {};
          });
      } else {
        that.$axios
          .post(that.$url_prefix + "deleleteXiaojiSale", param)
          .then(function (res) {
            console.log(res);
            that.centerDialogVisible = false;
            that.getXiaojiSale();
            that.search = "";
            that.userInfo = {};
          });
      }
    },
    handleBind(e) {
      let that = this;
      if (that.search === "") {
        that.$message({
          type: "warning",
          message: "请先选择绑定楼盘",
        });
        return;
      }
      let param = {
        estate_id: that.search,
        sale_id: that.sale_id,
      };
      if (e === 1) {
        that.$axios
          .post(that.$url_prefix + "setXiaojiSale", param)
          .then(function (res) {
            console.log(res);
            that.handleVisible = false;
            that.getXiaojiSale();
            that.search = "";
          });
      } else {
        that.$axios
          .post(that.$url_prefix + "deleleteXiaojiSale", param)
          .then(function (res) {
            console.log(res);
            that.handleVisible = false;
            that.getXiaojiSale();
            that.search = "";
          });
      }
    },
    selectUser(e) {
      this.userInfo = e;
      console.log(this.userInfo);
    },

    showInput(e) {
      this.dialogVisible = true;
      this.label = e.labels.slice();
      this.sale_id = e.sale_id;
    },
    showInput2() {
      this.inputVisible = true;
    },

    handleInputConfirm(e) {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.label.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClick(e, type) {
      this.handleVisible = true;
      this.search = "";
      this.sale_id = e.sale_id;
      this.estateInfos = e.estateInfos;
      this.handleType = type;
    },
    modifyTag() {
      let that = this;
      let param = {
        labels: that.label,
        sale_id: that.sale_id,
      };
      that.$axios
        .post(that.$url_prefix + "setSaleLabels", param)
        .then(function (res) {
          console.log(res);
          that.dialogVisible = false;
          that.getXiaojiSale();
          that.label = [];
          that.sale_id = "";
        });
    },
    searchEstate(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              type: "新房",
              search: search,
            },
          })
          .then((res) => {
            that.matchEstates = res.data.data;
            that.estateValue = search;
          });
      }
    },
    handleClose(tag) {
      this.label.splice(this.label.indexOf(tag), 1);
    },
    searchUser() {
      let that = this;
      if (that.searchUserName) {
        that.$open();
        that.$axios
          .get(that.$url_prefix + "searchUserByName", {
            params: {
              search: that.searchUserName,
            },
          })
          .then((res) => {
            console.log("res", res);
            that.$close();
            if (res.data.data.length) {
              that.nameSearchUsers = res.data.data;
            } else {
              that.$message.error("未找到此用户");
            }
          })
          .catch((err) => {
            that.$close();
            that.$message.error("搜索失败");
          });
      }
    },
    delImage(e) {
      // 删除
      e.photo = "";
    },
    upImage(e) {
      let that = this;
      that.$open();
      that.$axios
        .post(that.$url_prefix + "setSalePhoto", {
          sale_id: e.sale_id,
          photo: e.photo,
        })
        .then((res) => {
          console.log("res", res);
          that.$close();
          that.$message("上传成功");
        })
        .catch((err) => {
          that.$close();
          that.$message.error("搜索失败");
        });
    },
    //上传图片
    chooseImage(event, e) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "potrait",
      };
      that
        .$uploadImage(option)
        .then(function (res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return;
          }
          if (e.photo) e.photo = res;
          else that.$set(e, "photo", res);
          console.log(e);
          that.$previewRefresh();
        })
        .catch(function (res) {
          console.log("upload fail", res);
        });
    },
  },
};
</script>

<style scoped>
.occupancyContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.imageBox {
  margin: 20px auto;
}
.estates{
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/officialAgent.vue